// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"183":"information","302":"ad-account","594":"about","792":"main","883":"shop"}[chunkId] + "." + {"183":"d28c9d46","302":"ad484b05","594":"5b1e031d","792":"9e6337e5","883":"476cd35d"}[chunkId] + ".js";
};